import englishMessages from 'ra-language-english';
import specific from '../../config/i18n/en.json';

const enMessages = {
    ...englishMessages,
    ...specific,
}

export default enMessages;